import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Section = styled.section`
  padding: 128px 0 64px;
  background: var(--nd-black);
`;

const Kicker = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin: 0 0 16px;
`;

const Title = styled.h1`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 56px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 24px;
  @media (max-width: 768px) { font-size: 36px; }
`;

const Lede = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  max-width: 640px;
  margin: 0 0 48px;
`;

const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); gap: 24px; }
`;

const Stat = styled.div`
  border-left: 1px solid var(--nd-border-visible);
  padding-left: 14px;
`;

const Num = styled.div`
  font-family: 'Doto', 'Space Mono', monospace;
  font-size: 32px;
  font-weight: 700;
  color: var(--nd-text-display);
  line-height: 1;
`;

const Label = styled.div`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-top: 8px;
`;

const STATS = [
  { n: "12+", label: "years cloud" },
  { n: "50+", label: "deployments" },
  { n: "99.9%", label: "uptime" },
  { n: "$500K+", label: "saved" },
];

const HowWeWorkHero = () => (
  <Section>
    <Container>
      <Kicker>How we work</Kicker>
      <Title>Embed. Audit. Build. Operate.</Title>
      <Lede>
        Senior DevOps engineers join your team, audit what you have,
        fix the worst gaps first, then stay on to run it with you.
        No frameworks, no slide decks — just engineers doing the work
        while your team learns the stack.
      </Lede>
      <Stats>
        {STATS.map((s) => (
          <Stat key={s.label}>
            <Num>{s.n}</Num>
            <Label>{s.label}</Label>
          </Stat>
        ))}
      </Stats>
    </Container>
  </Section>
);
export default HowWeWorkHero;
